import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {Flex, Skeleton} from "antd";
import {CategoryListCard, CategoryListHeader} from "../../components";
import {CategoryListProps} from "../../models";
import {getProductCategoryList} from "../../../../shared";
import SubCategoryPopup from "../../components/subCategoryPopup/SubCategoryPopup";
import ProvinceCard from "../../../../shared/components/location/provinceCard/ProvinceCard";
import CitiesCard from "../../../../shared/components/location/citiesCard/CitiesCard";
import categories from "../../../../shared/assets/categoryList";
import {useNavigate} from "react-router-dom";

const SubCategoryList = ({getProductCategoryList}:CategoryListProps ) => {
    const [dataSourceWithIndex, setdataSourceWithIndex] =
        useState<any[]>([]);
    const [open, setOpen] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false);
    const [categoryId, setCategoryId] = useState<number>();
    const onCansel = () => {
        setOpen(false)
    }
    const navigate = useNavigate();
    // const getList = () => {
    //     setLoading(true);
    //     getProductCategoryList()
    //         .then((data: any) => {
    //             setLoading(false)
    //             if (data.payload != undefined) {
    //
    //                 setdataSourceWithIndex(data.payload.data);
    //
    //                 setLoading(false);
    //             } else {
    //                 setLoading(false);
    //             }
    //         })
    //         .catch((e: any) => {
    //         });
    // };
    // useEffect(() => {
    //     getList();
    // }, []);
    return (
        <Flex vertical gap={"small"}>
            <CategoryListHeader/>
            {loading ?<Flex vertical >
                    <Skeleton round active/>
                    <Skeleton round active/>
                    <Skeleton round active/>
                </Flex> :
                categories.map((item:any) =>
                    <CategoryListCard data={item}  onCategoryClick={(id:number) =>{
                        navigate("/sub-category-list/"+id);
                        setOpen(true)
                    }}/>
                )
            }



        </Flex>
    );
};

export default connect(null, {getProductCategoryList})(withRouter(SubCategoryList));
